import { Injectable } from '@angular/core';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ITProyecto } from '../models/IProyectos.model'

@Injectable({
    providedIn: 'root'
})

export class ConfigContaProyectosService {

    constructor(private apiService: ApiService) { }

    insertar(data: ITProyecto): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url+'tproyecto');
        return this.apiService.executePostJson(data).pipe();
    }

    modificar(data: ITProyecto): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url+'tproyecto');
        return this.apiService.executePutJson(data).pipe();
    }

    eliminar(codigo: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url+'tproyecto');
        return this.apiService.executeDeleteJson(`/${codigo}`)
    }


    obtener(codigo: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url+'tproyecto');
        return this.apiService.execGetQueryJson(`/${codigo}`)
    }

    buscar(descri: string, limit : number , offset : number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url+'tproyecto/buscar?');
        return this.apiService.execGetQueryJson(`descri=${descri}&limit=${limit}&offset=${offset}`)
    }


}